import React from 'react';

function YouTubeEmbed({ url, title = 'Video' }) {
  const getYouTubeID = (input) => {
    if (!input || typeof input !== 'string') return null;

    const raw = input.trim();
    if (!raw) return null;

    // Keep compatibility with already-stored plain IDs.
    if (/^[A-Za-z0-9_-]{11}$/.test(raw)) return raw;

    const normalized = /^https?:\/\//i.test(raw) ? raw : `https://${raw}`;

    let parsed;
    try {
      parsed = new URL(normalized);
    } catch {
      return null;
    }

    const host = parsed.hostname.toLowerCase().replace(/^www\./, '');
    const isYouTubeHost =
      host === 'youtube.com' ||
      host.endsWith('.youtube.com') ||
      host === 'youtube-nocookie.com' ||
      host.endsWith('.youtube-nocookie.com') ||
      host === 'youtu.be' ||
      host.endsWith('.youtu.be');

    if (!isYouTubeHost) return null;

    let videoId = null;
    const pathParts = parsed.pathname.split('/').filter(Boolean);

    if (host === 'youtu.be' || host.endsWith('.youtu.be')) {
      videoId = pathParts[0] || null;
    } else {
      videoId = parsed.searchParams.get('v');
      if (!videoId && pathParts.length > 1 && ['embed', 'v', 'shorts', 'live'].includes(pathParts[0])) {
        videoId = pathParts[1];
      }
    }

    return /^[A-Za-z0-9_-]{11}$/.test(videoId || '') ? videoId : null;
  };

  const videoId = getYouTubeID(url);
  if (!videoId) return <p>Invalid YouTube URL</p>;

  // Strip as much player chrome as the embed API allows: no control bar,
  // no related videos, no annotations, no keyboard, minimal branding.
  // (controls=0 removes the bottom bar; rel/modestbranding/iv_load_policy
  // remove most of the top/overlay clutter. YouTube no longer lets the
  // title overlay be fully removed, but this is as clean as it gets.)
  const params = new URLSearchParams({
    controls: '0',
    modestbranding: '1',
    rel: '0',
    iv_load_policy: '3',
    disablekb: '1',
    fs: '0',
    playsinline: '1',
  });
  const embedUrl = `https://www.youtube-nocookie.com/embed/${videoId}?${params.toString()}`;

  return (
    <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0 }}>
      <iframe
        src={embedUrl}
        title={title}
        style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </div>
  );
}

export default YouTubeEmbed;
